import Axios from 'axios';
import { API_URL } from '../../../../lib/const';

const baseUrl = `${API_URL}/transfers/document-approval-appropriations`;

export const fetchTransferDocumentAppropriations = (applicationId: number) => (
  Axios.get(baseUrl, {
    params: { application: applicationId, ordering: '-start_date' },
  })
    .then(response => response.data)
);

export const createTransferDocumentAppropriation = (applicationId: number) => (
  Axios.post(baseUrl, { application: applicationId })
    .then(response => response.data)
);

export const transferTransferDocumentAppropriation = (
  appropriationId: number,
  userId: number,
) => (
  Axios.post(`${baseUrl}/${appropriationId}/transfer`, { user: userId })
    .then(response => response.data)
);

export const fetchEligibleTransferAppropriationUsers = (
  applicationId: number,
  search: string,
) => (
  Axios.get(`${baseUrl}/eligible_users`, {
    params: { application: applicationId, search },
  }).then(response => ({ results: response.data }))
);
